import MobileNews from './MobileNews';

export default MobileNews;
